webpackJsonp([216635586879231],{

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(27);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(26);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
		var imgSizes = _ref.imgSizes,
		    downloads = _ref.downloads,
		    title = _ref.title;
		return Glamor.createElement(
			"div",
			null,
			Glamor.createElement(
				"div",
				{ css: { margin: "0 0.5rem" } },
				Glamor.createElement(
					_gatsbyLink2.default,
					{ css: { float: "right" }, to: "/" },
					"Back"
				),
				Glamor.createElement(
					"h3",
					null,
					title
				)
			),
			Glamor.createElement(_gatsbyImage2.default, { sizes: imgSizes }),
			Glamor.createElement(
				"p",
				{ css: {
						textAlign: "center",
						marginTop: "1em"
					} },
				"Downloads: ",
				Glamor.createElement(
					"a",
					{ href: downloads.med, download: true },
					"medium"
				),
				" / ",
				Glamor.createElement(
					"a",
					{ href: downloads.lrg, download: true },
					"large"
				)
			)
		);
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/burdock_board_large.4e06f9b6.jpg";

/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/burdock_board_medium.0ffd2dd5.jpg";

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoardPage = __webpack_require__(46);
	
	var _BoardPage2 = _interopRequireDefault(_BoardPage);
	
	var _burdock_board_medium = __webpack_require__(629);
	
	var _burdock_board_medium2 = _interopRequireDefault(_burdock_board_medium);
	
	var _burdock_board_large = __webpack_require__(628);
	
	var _burdock_board_large2 = _interopRequireDefault(_burdock_board_large);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var query = exports.query = "** extracted graphql fragment **";
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  return Glamor.createElement(_BoardPage2.default, {
	    imgSizes: data.file.childImageSharp.sizes,
	    downloads: { med: _burdock_board_medium2.default, lrg: _burdock_board_large2.default },
	    title: "Burdock"
	  });
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-burdock-js-367e41a842629d02c8f9.js